import Badge from '../../components/base/Badge';
import React, { useState } from 'react';
import { ordersTableData } from '../../data/orders';
import { Card, Modal, ProgressBar } from 'react-bootstrap';
import Button from '../../components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AvatarDropdown from '../../components/common/AvatarDropdown';
import Avatar from '../../components/base/Avatar';
import classNames from 'classnames';
// import CardViewModal from './CardViewModal';
import { currencyFormat } from '../../helpers/utils';
import useProjectProgress from '../../components/project-management/useProjectProgress';
import {
  faChevronRight,
  faCreditCard,
  faListCheck,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { orderProducts } from '../../helpers/orderProducts';
import OrderCablesDetail from './OrderCablesDetail';
import { clientBadgeColor } from '../../helpers/sourceBreakdown';

const CardViewItem = ({ project }) => {
  const [showCables, setShowCables] = useState(false);
  const cables = orderProducts(project);
  const cableCount = cables.length;

  //   const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const navigate = useNavigate();

  // Real fulfilment from the backend compute-on-read rollup (order.production),
  // falling back to produced/ordered. (This is a real order, not the demo
  // "project" shape — so useProjectProgress' status.type-based classes don't
  // apply and were painting the bar grey.)
  const lines = Array.isArray(project?.lines) ? project.lines : [];
  const orderedM = lines.reduce((s, l) => s + Number(l.totalOrderedLength || 0), 0);
  const producedM = lines.reduce((s, l) => s + Number(l.producedLength || 0), 0);
  const fulfillmentPct = Number(
    project?.production?.fulfillmentPct ??
      (orderedM > 0 ? Math.round((producedM / orderedM) * 100) : 0)
  );
  const progressVariant =
    fulfillmentPct >= 100 ? 'success' : fulfillmentPct > 0 ? 'info' : 'secondary';

  // real order status → label + color (this is an ORDER, not the old demo
  // "project" shape that had status.{type,label})
  const STATUS = {
    pending: { label: 'Pending', color: 'warning' },
    in_progress: { label: 'In Progress', color: 'info' },
    processing: { label: 'In Progress', color: 'info' },
    completed: { label: 'Completed', color: 'success' },
    cancelled: { label: 'Cancelled', color: 'secondary' }
  };
  const sKey = String(project?.status || '').toLowerCase();
  const st =
    STATUS[sKey] || { label: sKey ? sKey.replace(/_/g, ' ') : '—', color: 'secondary' };
  const fmtDate = d => (d ? dayjs(d).format('DD MMM YYYY') : '—');

  return (
    <>
      <Card className="h-100 hover-actions-trigger">
        <Card.Body>
          <div className="d-flex align-items-center">
            <h4 className="mb-2 line-clamp-1 lh-sm flex-1 me-5">
              {project.orderCode || `id ${project.orderId}`}
            </h4>
            <div className="hover-actions top-0 end-0 mt-4 me-4">
              <Button
                variant="primary"
                className="btn-icon flex-shrink-0"
                onClick={() =>
                  navigate(
                    `/apps/sales-management/order-details/${project.orderId}`
                  )
                }
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </Button>
            </div>
          </div>
          <Badge
            variant="phoenix"
            bg={st.color}
            className="fs-10 mb-4 text-capitalize"
          >
            {st.label}
          </Badge>
          <div className="d-flex align-items-center mb-2">
            <FontAwesomeIcon
              icon={faUser}
              className="me-2 text-700 fs-9 fw-extra-bold"
            />
            <p className="fw-bold mb-0 text-truncate lh-1">
              Client :{' '}
              <span className="fw-semi-bold text-primary ms-1">
                {' '}
                {project.client}
              </span>
            </p>
          </div>
          <div className="d-flex align-items-center mb-4">
            <FontAwesomeIcon
              icon={faCreditCard}
              className="me-2 text-700 fs-9 fw-extra-bold"
            />
            <p className="fw-bold mb-0 text-truncate lh-1">
              Ordered :{' '}
              <span className="text-1100 ms-1">
                {orderedM.toLocaleString()} m
              </span>
            </p>
          </div>
          <div className="d-flex justify-content-between text-700 fw-semi-bold">
            <p className="mb-2"> Fulfillment</p>
            <p className="mb-2 text-1100">{fulfillmentPct}%</p>
          </div>
          <ProgressBar
            now={fulfillmentPct}
            className="flex-1"
            variant={progressVariant}
          />

          <div>
            <div className="d-flex align-items-center mt-4">
              <p className="mb-0 fw-bold fs-9">
                Started :
                <span className="fw-semi-bold text-600 ms-1">
                  {fmtDate(project.createdAt)}
                </span>
              </p>
            </div>
            <div className="d-flex align-items-center mt-2">
              <p className="mb-0 fw-bold fs-9">
                Deadline :{' '}
                <span className="fw-semi-bold text-600 ms-1">
                  {fmtDate(project.dueDate)}
                </span>
              </p>
            </div>

            <div className="d-flex d-lg-block d-xl-flex justify-content-between align-items-center mt-3">
              {/* <div className="d-flex gap-1">
                <Avatar.Group total={project.assigness.length} size="m">
                  {project.assigness.slice(0, 4).map(assigne => (
                    <AvatarDropdown user={assigne} size="m" key={assigne.id} />
                  ))}
                </Avatar.Group>
              </div> */}

              {/* The way into the cables. Listing them on the card itself
                  would grow it with the order — a customer with a dozen
                  cables would own the grid — so the count is the handle and
                  the detail opens over it. */}
              <div
                className="mt-lg-3 mt-xl-0"
                role="button"
                style={{ cursor: 'pointer' }}
                title="Show the cables and their metres"
                onClick={e => {
                  // The whole card is a link to the order; this is not.
                  e.preventDefault();
                  e.stopPropagation();
                  setShowCables(true);
                }}
              >
                <FontAwesomeIcon icon={faListCheck} className="me-1" />

                <p className="d-inline-block fw-bold mb-0 text-primary">
                  {cableCount}
                  <span className="fw-normal">
                    {' '}
                    {cableCount === 1 ? 'cable' : 'cables'}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>

      <Modal show={showCables} onHide={() => setShowCables(false)} centered size="lg">
        <Modal.Header>
          {/* Order and client side by side, stacking on a narrow screen —
              they are one identity and reading them on two lines on a wide
              display wastes the only part of the header that says anything. */}
          <div className="d-flex align-items-center gap-3 flex-wrap flex-grow-1">
            <span className="fw-bold fs-7">
              {project.orderCode || `id ${project.orderId}`}
            </span>
            <Badge bg={clientBadgeColor(project.client)} className="fs-9 fw-bold">
              {String(project.client || '—').toUpperCase()}
            </Badge>
          </div>
          {/* Red, and its own button: the stock close is a faint grey cross
              that is hard to find against a busy modal. */}
          <Button
            variant="link"
            className="text-danger fs-6 p-0 lh-1 text-decoration-none"
            aria-label="Close"
            onClick={() => setShowCables(false)}
          >
            ✕
          </Button>
        </Modal.Header>
        <Modal.Body>
          <OrderCablesDetail order={project} />
        </Modal.Body>
      </Modal>

      {/* <CardViewModal
        show={openDetailsModal}
        handleClose={() => setOpenDetailsModal(false)}
        project={project}
      /> */}
    </>
  );
};

export default CardViewItem;
